import ProductDetail from './ProductDetail.jsx';

export {
  ProductDetail
}


// WEBPACK FOOTER //
// ./components/product-detail/index.js